import {ActivatedRouteSnapshot, RouterStateSnapshot, Routes} from '@angular/router';
import {PropertyListComponent} from 'web-shared';
import {PropertyResolver} from 'web-shared';
import {PropertyEditStateComponent} from 'web-shared';
import {LocalizationListComponent} from "./localizations/localization-list/localization-list.component";
import {GLOBAL} from "common-shared";
import {ClassificatorListComponent} from "web-shared";
import {ParameterListComponent} from "web-shared";
import {UserService} from "web-shared";
import {inject} from "@angular/core";
import {EventListComponent} from "../components/events/event-list/event-list.component";
import {UserListComponent} from "../components/user/list/user-list.component";
import {ContactListComponent} from "./contact/contact-list/contact-list.component";

export const CommonRoutes: Routes = [
  {path: '', redirectTo: 'property', pathMatch: 'full'},
  {
    path: 'property', data: {
      breadcrumb: 'Specs'
    }, children: [
      {
        path: '', children: [
          {
            path: '',
            component: PropertyListComponent,
            data: {
              actionbar: false,
              search: {
                advanced: true,
                enabled: true
              }
            }
          },
        ]
      },
      {
        path: 'add', children: [
          {
            path: '',
            component: PropertyEditStateComponent,
            data: {
              actionbar: false
            }
          }
        ]
      },
      {
        path: 'edit/:id', resolve: {entity: PropertyResolver}, children: [
          {
            path: '',
            component: PropertyEditStateComponent,
            data: {
              actionbar: false
            }
          }
        ]
      }
    ]
  },
  {
    path: 'classificator', data: {
      breadcrumb: 'Classificator'
    }, children: [
      {
        path: '', children: [
          {
            path: '',
            component: ClassificatorListComponent,
            data: {
              actionbar: false,
              search: {
                advanced: false,
                enabled: true
              }
            }
          }
        ]
      }
    ]
  },
  {
    path: 'localization',
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(UserService).canActivate(route, state)],
    data: {
      expectedPrivilege: GLOBAL.Privileges.EditLocalization,
      breadcrumb: 'Localizations'
    }, children: [
      {
        path: '', children: [
          {
            path: '',
            component: LocalizationListComponent,
            data: {
              actionbar: false,
              search: {
                advanced: false,
                enabled: true
              }
            }
          }
        ]
      }
    ]
  },
  {
    path: 'user',
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(UserService).canActivate(route, state)],
    data: {
      expectedPrivilege: GLOBAL.Privileges.EditUser,
      breadcrumb: 'Users'
    }, children: [
      {
        path: '', children: [
          {
            path: '',
            component: UserListComponent,
            data: {
              actionbar: false,
              search: {
                advanced: true,
                enabled: true
              }
            }
          }
        ]
      }
    ]
  },
  {
    path: 'event',
    data: {
      breadcrumb: 'Events'
    }, children: [
      {
        path: '', children: [
          {
            path: '',
            component: EventListComponent,
            data: {
              actionbar: false
            }
          }
        ]
      }
    ]
  },
  {
    path: 'contact', data: {
      breadcrumb: 'Contacts'
    }, children: [
      {
        path: '', children: [
          {
            path: '',
            component: ContactListComponent,
            data: {
              actionbar: false,
              search: {
                advanced: false,
                enabled: true
              }
            }
          }
        ]
      }
    ]
  },
  {
    path: 'parameter',
    data: {
      breadcrumb: 'Parameters'
    }, children: [
      {
        path: '', children: [
          {
            path: '',
            component: ParameterListComponent,
            data: {
              actionbar: false
            }
          }
        ]
      }
    ]
  },
];
